// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
import authReducer from "./authSlice";
// import dataReducer from './dataSlice';
import donorSlice from "./donorSlice";
import donationSlice from "./donationSlice"
import { combineReducers } from "redux";
import reportSlice from "./reportBookwiseSlice";
import labelSlice from "./labelSlice";
import npfuafSlice from "./npfuafSlice";
import donationReportSlice from "./reportDonationSlice";
import importDataSlice from "./importDataSlice";
import pancardReportSlice from "./reportPanCardSlice";
import summaryReportSlice from "./reportSummarySlice";
import manageoptionsSlice from "./dropdownoptionsSlice";
import PaypurposeSlice from "./paypurposeSlice";
import reportSettingsReducer from "./reportSettingsSlice";

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist the auth slice
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  donor: donorSlice,
  donation: donationSlice,
  report: reportSlice,
  donationReport: donationReportSlice,
  label: labelSlice,
  npfuaflabel: npfuafSlice,
  pancardReport: pancardReportSlice,
  summaryReport: summaryReportSlice,
  dropdownOptions: manageoptionsSlice, 
  paypurpose: PaypurposeSlice,
  importData: importDataSlice,
  reportSettings: reportSettingsReducer,
});

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with redux-logger in development
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      process.env.NODE_ENV === "development" ? logger : []
    ),
});

export const persistor = persistStore(store);
export default store;
